import React, { useState, useEffect, useContext } from 'react';
import { getFirebaseApp } from '../utils/firebase';
import 'firebase/auth';
var AuthContext = React.createContext(undefined);
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), user = _b[0], setUser = _b[1];
    useEffect(function () {
        return getFirebaseApp()
            .auth()
            .onIdTokenChanged(function (user) {
            console.debug('Loaded user', user);
            setUser(user);
        }, function (err) {
            console.log('Error loading Auth info:', err);
        });
    }, []);
    return React.createElement(AuthContext.Provider, { value: user }, children);
};
export var useAuth = function () {
    return useContext(AuthContext);
};
//# sourceMappingURL=Auth.js.map